import { NoItemFound } from '@/components/atomic/atoms';
import { CartList } from '@/components/atomic/molecules';
import { Text } from '@/components/atomic/nuclei';
import { CART_LIST_TYPE } from '@/config/common';
import {
  filterActiveCart,
  filterArchivedCart,
  filterOrderedCart
} from '@/services/myEvents.service';

const EventCartListsOrganism = ({ userEventCartList }) => {
  const cartCardList = [
    {
      cartListType: CART_LIST_TYPE.EVENT,
      filteredCartItems: userEventCartList.filter(filterActiveCart),
      title: 'Event Cart List'
    },
    {
      cartListType: CART_LIST_TYPE.ORDER,
      filteredCartItems: userEventCartList.filter(filterOrderedCart),
      showControlToCollapseList: true,
      title: 'Event Order List'
    },
    {
      cartListType: CART_LIST_TYPE.ARCHIVE,
      filteredCartItems: userEventCartList.filter(filterArchivedCart),
      showControlToCollapseList: true,
      title: 'Archived Carts'
    }
  ];

  if (!userEventCartList.length) {
    return (
      <>
        <Text
          {...{
            className:
              'text-base md:text-xl font-medium font-Montserrat flex self-center mt-6',
            content: 'Event Cart List'
          }}
        />
        <NoItemFound />
      </>
    );
  }

  return (
    <div>
      {cartCardList.map(
        ({ filteredCartItems, showControlToCollapseList, title }, index) =>
          filteredCartItems.length > 0 && (
            <CartList
              key={index}
              {...{
                showControlToCollapseList,
                title,
                userEventCartList: filteredCartItems
              }}
            />
          )
      )}
    </div>
  );
};

export default EventCartListsOrganism;
